"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appConstants = require("../appConstants");
var initialState = {
  bundleDetails: null,
  isLoading: false,
  hasError: false,
  fetchingBundleError: null,
  currentPurchaseModalScreen: _appConstants.SCREENS.confirmation,
  purchaseFlowError: null
};
var _default = initialState;
exports.default = _default;